import React, { useEffect } from 'react';
import MaterialCommunityIcons from 'react-native-vector-icons/dist/MaterialCommunityIcons';
import { MaterialCommunityIcons as Singleton } from './MaterialCommunityIcons';


const Loader = props => {

  const {
    onLoaded,
  } = props;

  useEffect(
    () => {
      Singleton.Set(MaterialCommunityIcons);
      if (onLoaded) {
        onLoaded();
      }
    },
    [
      onLoaded,
    ],
  );

  return <></>;
};

export default Loader;
